import { gql } from "@apollo/client";

const GET_COUPONS = gql`
  query coupons(
  $params: QueryParams
  $name: String
  $all: Boolean
  ) {
    coupons(
    params: $params
    name: $name
    all: $all
    ) {
      info {
        count
      }
      results {
        id
        name
        description
        conditions
        img
        comparePrice
        totalPrice
        expires
        limitPerClient
        renewal
        privateType
        code
        type
        discountType
        discount
        minPurchase
        minQuantity
        maxDiscount
        productCoupon {
          id
          name
          description
          categories {
            id
            category {
              name
              description
              img
              priority
            }
          }
          variants {
            id
            title
            img
            description
            price
            isPrimaryVariant
            product {
              name
              description
            }
          }
          type
          rulesAdditionals {
            requireComplements
            maxComplements
            complementItems {
              id
              title
              img
              description
              price
              product {
                id
                name
                description
              }        
            }
            requireBeverages
            maxBeverages
            beverageItems {
              id
              title
              img
              description
              price
              product {
                id
                name
                description
              }  
            }
            includesExtras
            extraRules {
              product {
                id
                name
                description
                type
              }
              max
              required
            }
          }
        }
        giftVariants {
          id
          title
          product {
            id
            name
            description
          }
        }
        groups {
          id
          group
        }
        oneTimeUse
      }
    }
  }
`;

const GET_CATEGORIES_SORTED = gql`
  query groupsCoupon($params: QueryParams) {
    groupsCoupon(params: $params) {
      info {
        count
      }
      results { 
        id
        group
        priority
      }    
    }
  }
`;

const DELETE_COUPON = gql`
  mutation deleteCoupon($id: ID!) {
    deleteCoupon(id: $id)
  }
`;

export { GET_COUPONS, GET_CATEGORIES_SORTED, DELETE_COUPON };
